var _ellipse, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMyProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 18,
    className: "profile",
    viewBox: "0 0 15 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.64914,
    cy: 5.06495,
    rx: 3.98169,
    ry: 3.98169,
    stroke: "inherit",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.33336 14.5844C1.33229 14.3045 1.39489 14.028 1.51642 13.7758C1.89781 13.0131 2.97333 12.6088 3.86578 12.4257C4.50941 12.2884 5.16193 12.1966 5.81848 12.1511C7.03404 12.0444 8.25662 12.0444 9.47218 12.1511C10.1287 12.1971 10.7812 12.2889 11.4249 12.4257C12.3173 12.6088 13.3929 12.9749 13.7742 13.7758C14.0187 14.2898 14.0187 14.8866 13.7742 15.4006C13.3929 16.2015 12.3173 16.5676 11.4249 16.743C10.782 16.8861 10.1293 16.9804 9.47218 17.0253C8.48282 17.1091 7.48883 17.1244 6.49735 17.071C6.26852 17.071 6.04732 17.071 5.81848 17.0253C5.16387 16.981 4.51361 16.8866 3.8734 16.743C2.97333 16.5676 1.90544 16.2015 1.51642 15.4006C1.39551 15.1455 1.33297 14.8667 1.33336 14.5844Z",
    stroke: "inherit",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyProfile);
export default __webpack_public_path__ + "static/media/my-profile.968dfa9e587250c6c924689829193885.svg";
export { ForwardRef as ReactComponent };